import Button from '@portalterreno/react-ui-core/Button';
import { useTranslation } from 'next-i18next';
import { FC, useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { sendMultipleLeads } from '../../../redux/slices/multipleLeads';
import { RootState } from '../../../redux/store';

export const RECAPTCHA_ACTION = 'contactForm';

const LeadButton: FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['property']);

  const isLoading = useSelector(
    (state: RootState) => state.multipleLeads.isLoading,
    shallowEqual
  );

  const handleOnClick = useCallback(() => {
    dispatch(sendMultipleLeads());
  }, [dispatch]);

  return (
    <Button
      color='midnight'
      onClick={handleOnClick}
      loading={isLoading}
    >
      {t('property:multipleLeadModalContactButton')}
    </Button>
  );
};

export default LeadButton;
